// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__2E8b7","sendOtp":"AuthorizeToLogin_sendOtp__2mvYo"};